/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { Component } from "react";
import { getMessage } from "utils/TranslationUtil";
import panIcon from "dc-icons/viewer2021/SDC_Hand_18_N.svg";
import * as stores from "stores";
import { actionTags, supportedFileExtensions } from "constants/enums";
import { modifyCursorApis } from "publicApis/OldPublicApis";
import { cursorType } from "constants/enums";

class PanBootstrap extends Component {
  constructor() {
    super();
  }

  getLabel = () => getMessage("label.pan");

  getIcon = () => panIcon;

  getTooltip = () => getMessage("modernviewer.tooltip.pan");

  getAriaLabel = () => getMessage("modernviewer.arialabel.pan");

  getActionTags = () => [actionTags.LOCAL];

  getFileSelectionParams = () => ({
    acceptExtensions: Object.values(supportedFileExtensions),
    acceptConnectors: "all"
  });

  id = "preview-pan";

  initializeAction = opts => {
    opts.showCallback(true);
  };

  exitCallback = () => {
    stores.appStore.setPanActive(false);
    return new Promise((resolve, reject) => resolve());
  };

  executeAction = opts => {
    stores.appStore.setPanActive(true);
    const { executeCallback } = opts;
    executeCallback && executeCallback();
    modifyCursorApis(stores)
      .apiGetter()
      .setCursor(cursorType.GRAB);
  };

  render() {
    return null;
  }
}

export default PanBootstrap;
